import React, { useState } from "react";
import { useAppContext } from "../../context/appContext";
import { Input, TextArea, RadioPickButton, Select, FancySelect } from "../../components/workspace";
import EmailReportForm from "../../components/EmailReportForm";
import { isEqual } from "lodash";

function Appointments() {
  const {
    appointments,
    appointmentsOriginal,
    job,
    lists,
    indices,
    displayAlert,
    isLoading,
    handleChange,
    handleArrayChanges,
    showReportForm,
  } = useAppContext();
  const index = indices.appointmentsIndex;

  const [selectedRow, setSelectedRow] = useState(null);

  const employeeOptions =
    lists &&
    lists.listServiceReps?.map((row) => {
      return { value: row.id, label: row.text };
    });

  const handleInput = (e, isNumber) => {
    const property = e.target.name;
    const value = isNumber ? parseInt(e.target.value) : e.target.value;
    const baseArray = [...appointments];
    const baseName = "appointments";
    handleArrayChanges({
      baseName,
      baseArray,
      index,
      newValues: { [property]: value },
    });
  };

  const selectTblRow = async (apptId, row) => {
    // set appointmentsIndex
    handleChange({
      baseObject: { ...indices },
      name: "indices.appointmentsIndex",
      value: row,
    });
    setSelectedRow(apptId);
  };

  const handleEmployee = (selected) => {
    console.log("selected:", selected);
    const empIds = selected.map((item) => item.value);
    console.log("selected ids:", empIds);

    handleArrayChanges({
      baseName: "appointments",
      baseArray: [...appointments],
      index: index,
      newValues: { employees_ids: empIds },
    });
  };

  const newAppt = async (e) => {
    e.preventDefault();
    if (!job.id) {
      displayAlert("Please select a job");
      return;
    }
    const today = new Date().toISOString().slice(0, 10);
    handleArrayChanges({
      baseName: "appointments",
      baseArray: [...appointments],
      index: appointments.length || 0,
      newValues: {
        core_job_data_id: job.id,
        appt_date: today,
        appt_statuses_id: 1,
        employees_ids: [],
      },
    });
    // set appointmentsIndex
    handleChange({
      baseObject: { ...indices },
      name: "indices.appointmentsIndex",
      value: appointments.length || 0,
    });
  };

  const lastAppt = appointments[appointments?.length - 1];

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <div className="page appointments">
      {/* ----- Appointments ------ */}
      <div className="group whole">
        <form className="form unsaved-container" onSubmit={handleSubmit}>
          {!isEqual(appointments, appointmentsOriginal) && (
            <div className="unsaved-dot" title="Unsaved changes" />
          )}
          <h3>Appointments</h3>
          <div className="form-center">
            <div className="form-row whole">
              <table>
                <tbody>
                  <tr>
                    <th style={{ width: 150 }}>Type</th>
                    <th style={{ width: 150 }}>Date</th>
                    <th style={{ width: 150 }}>Service Rep</th>
                    <th className="mobile-no-show">Notes</th>
                  </tr>
                  {appointments?.map((appt, index) => {
                    return (
                      <tr
                        key={appt.id || 0}
                        className={selectedRow === appt.id ? "selected" : ""}
                        onClick={() => selectTblRow(appt.id, index)}
                      >
                        <td className="unsaved-container">
                          {!isEqual(appointments[index], appointmentsOriginal[index]) && (
                            <div className="unsaved-dot" title="Unsaved changes" />
                          )}
                          {appt.appt_types_id &&
                            lists.listApptTypes?.find((appointment) => {
                              return appointment.id === appt.appt_types_id;
                            })?.text}
                        </td>
                        <td>{appt.appt_date}</td>
                        <td>
                          {appt.employees_ids &&
                            lists.listAllServiceReps
                              ?.find((employee) => {
                                return employee.id === appt.employees_ids;
                              })
                              ?.map((rep) => rep.text)}

                          {appt.employees_ids &&
                            appt.employees_ids.map((empId, i) => {
                              const match = lists.listAllServiceReps?.find((employee) => {
                                return employee.id === empId;
                              }).text;
                              const empName = i > 0 ? ", " + match : match;

                              return empName;
                            })}
                        </td>
                        <td className="mobile-no-show">{appt.notes}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="btn-block">
              {appointments?.length > 0 && !lastAppt?.id ? (
                ""
              ) : (
                <button
                  name="newAppt"
                  className="btn"
                  type="button"
                  onClick={(e) => newAppt(e)}
                  disabled={isLoading}
                >
                  {isLoading ? "please wait..." : "New Appointment"}
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
      {/* ----- Details ------ */}
      <div className="group whole">
        <form className="form unsaved-container" onSubmit={handleSubmit}>
          {!isEqual(appointments[index], appointmentsOriginal[index]) && (
            <div className="unsaved-dot" title="Unsaved changes" />
          )}
          <h3>Details</h3>
          <div className="form-center">
            {appointments[index]?.core_job_data_id ? (
              <div className="whole flex-parent">
                <div className="one-half flex-parent sub-section">
                  {/* Appointment Status */}
                  <div className="whole">
                    <RadioPickButton
                      name="appt_statuses_id"
                      labelText="Appoinment Status"
                      handleChange={(e) => handleInput(e, true)} // designate isNumber to be true
                      value={appointments[index]?.appt_statuses_id || "default"}
                      options={lists && lists.listApptStatuses}
                      buttonClasses="one-third"
                    />
                  </div>
                  <div className="one-half sub-section">
                    <Select
                      name="appt_types_id"
                      labelText="Appointment Type"
                      handleChange={(e) => handleInput(e, true)} // designate isNumber to be true
                      value={appointments[index]?.appt_types_id || "default"}
                      options={lists.listApptTypes}
                    />
                  </div>
                  <div className="one-half">
                    <FancySelect
                      isMulti={true}
                      name="employees_ids"
                      labelText="Service Rep"
                      handleChange={handleEmployee}
                      value={appointments[index]?.employees_ids}
                      options={employeeOptions}
                    />
                  </div>

                  <div className="one-third sub-section">
                    <Input
                      type="date"
                      name="appt_date"
                      labelText="date"
                      value={appointments[index]?.appt_date || ""}
                      handleChange={(e) => handleInput(e)}
                    />
                  </div>
                  <div className="one-third sub-section">
                    <Input
                      type="time"
                      name="appt_time"
                      labelText="time"
                      value={appointments[index]?.appt_time || ""}
                      handleChange={(e) => handleInput(e)}
                    />
                  </div>
                  <div className="one-third">
                    <Input
                      type="text"
                      name="duration"
                      labelText="Duration (hrs)"
                      value={appointments[index]?.duration || ""}
                      handleChange={(e) => handleInput(e)}
                    />
                  </div>
                </div>
                <div className="one-half">
                  <TextArea
                    name="notes"
                    value={appointments[index]?.notes || ""}
                    handleChange={(e) => handleInput(e)}
                  />
                </div>
              </div>
            ) : (
              <div className="whole flex-parent">
                <h3>Please select an appointment...</h3>
              </div>
            )}
          </div>
        </form>
      </div>
      {/* ----- Email/ Report Confirmation Modal ------ */}
      <div className={showReportForm ? "show-modal modal-container" : "modal-container"}>
        <div className="group">
          <EmailReportForm />
        </div>
      </div>
    </div>
  );
}
export default Appointments;
